import React, { useEffect, useState } from 'react';
import InputGroup from 'react-bootstrap/InputGroup';
import { Card, Row, Col, Button, Form } from 'react-bootstrap';
import { getAllFacilityOrgList } from 'nursd-dashboard/api/organizationTable';
import { useAuth } from 'nursd-dashboard/context/AuthContext';
import { createFacility } from 'nursd-dashboard/api/facilityTable';
import { postFacilityNotification } from 'nursd-dashboard/api/facilityNotification';
import { socket } from 'nursd-dashboard/api/socket';
import { sendNotification } from 'nursd-dashboard/api/webNotification';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import Flex from 'components/common/Flex';
import { Link } from 'react-router-dom';
import paths from 'routes/paths';
import {
  formatPhoneNumber,
  removeFormatting
} from 'nursd-dashboard/utils/function';

function Create_facility() {
  const navigate = useNavigate();
  const [newFacility, setNewFacility] = useState({
    email: '',
    firstName: '',
    lastName: '',
    password: '',
    phoneNumber: '',
    facilityVerified: true,
    emailVerified: true
  });

  const handleInputChangeNewData = event => {
    setNewFacility(prevState => {
      return { ...prevState, [event.target.name]: event.target.value };
    });
  };

  const [validated, setValidated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [orgLocationIdData, setOrgLocationIdData] = useState([]);
  const { authToken, location, organization } = useAuth();

  const getFacility = async () => {
    try {
      const facilityList = await getAllFacilityOrgList(
        authToken,
        location,
        organization
      );

      const list = facilityList.sort((a, b) =>
        a.firstName.toLowerCase().localeCompare(b.firstName.toLowerCase())
      );
      setOrgLocationIdData(list);
    } catch (error) {
      console.log(error);
      setOrgLocationIdData([]);
    }
  };

  useEffect(() => {
    if (location !== '') {
      getFacility();
    }
  }, [authToken, location]);

  const dataCheck = !orgLocationIdData.some(serverItem => {
    return (
      serverItem.email === newFacility.email ||
      serverItem.phoneNumber === newFacility.phoneNumber
    );
  });

  const postManager = async () => {
    setLoading(true);
    if (dataCheck) {
      try {
        await createFacility(authToken, {
          email: newFacility.email,
          firstName: newFacility.firstName,
          lastName: newFacility.lastName,
          password: newFacility.password,
          phoneNumber: removeFormatting(newFacility.phoneNumber),
          location_id: location,
          organization: organization,
          emailVerified: newFacility.emailVerified,
          facilityVerified: newFacility.emailVerified
        })
          .then(res => {
            // console.log(res)
            toast.success(
              `${res?.firstName + ' ' + res?.lastName} created successfully.`,
              {
                theme: 'colored'
              }
            );
            getAllFacilityOrgList(authToken, location, organization)
              .then(async facilitiesData => {
                for (const facility of facilitiesData) {
                  if (Number(facility?.id) !== Number(res?.id)) {
                    try {
                      await postFacilityNotification(
                        authToken,
                        facility?.id,
                        '',
                        'New employee joined!',
                        `${
                          res?.firstName + ' ' + res?.lastName
                        } has been added as a new employee to your location.`,
                        'NotificationScreen',
                        {},
                        false,
                        false,
                        'green',
                        ''
                      );
                      socket?.emit('tableNotificationInsert', {
                        table: 'FacilityNotificationTable',
                        id: facility?.id
                      });
                      if (facility?.mobileId) {
                        sendNotification(authToken, {
                          expoPushToken: facility?.mobileId,
                          title: 'New employee joined!',
                          body: `${
                            res?.firstName + ' ' + res?.lastName
                          } has been added as a new employee to your location.`,
                          data: { screen: 'NotificationScreen' }
                        });
                      }
                    } catch (error) {
                      console.error('Error fetching facility detail:', error);
                    }
                  }
                }
              })
              .catch(error => console.error('Fetching facility:', error));
            setNewFacility({
              email: '',
              firstName: '',
              lastName: '',
              password: '',
              phoneNumber: '',
              facilityVerified: false,
              emailVerified: false
            });
            setLoading(false);
            navigate(paths.nursd_manager);
          })
          .catch(e => {
            setLoading(false);
            toast.error(e?.toString(), {
              theme: 'colored'
            });
            // console.log(e)
          });
      } catch (error) {
        setLoading(false);
        console.log('data save error:', error);
      }
    } else {
      setLoading(false);
      toast.error(
        `${
          newFacility?.firstName + ' ' + newFacility?.lastName
        } record already stored in database!`,
        {
          theme: 'colored'
        }
      );
    }
  };

  const handleSubmit = event => {
    event.preventDefault(); // Prevent default form submission behavior

    const form = event.currentTarget;
    // console.log(form.checkValidity());
    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
      return;
    }

    postManager();
  };

  return (
    <Card>
      <Card.Header>
        <h5 className="mb-0">Create Manager - {location}</h5>
      </Card.Header>
      <Card.Body>
        <Form
          noValidate
          validated={validated}
          onSubmit={loading ? null : handleSubmit}
        >
          <Row className="mb-3">
            <Form.Group as={Col} md="4" controlId="FirstName">
              <Form.Label>First name</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="First name"
                name="firstName"
                value={newFacility.firstName}
                onChange={handleInputChangeNewData}
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                Please enter a first name.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="4" controlId="LastName">
              <Form.Label>Last name</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Last name"
                name="lastName"
                value={newFacility.lastName}
                onChange={handleInputChangeNewData}
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                Please enter a last name.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="4" controlId="Email">
              <Form.Label>Email</Form.Label>
              <InputGroup hasValidation>
                <InputGroup.Text id="inputGroupPrepend">@</InputGroup.Text>
                <Form.Control
                  type="text"
                  placeholder="Email"
                  aria-describedby="inputGroupPrepend"
                  required
                  name="email"
                  value={newFacility.email}
                  onChange={handleInputChangeNewData}
                />
                <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">
                  Please enter a email.
                </Form.Control.Feedback>
              </InputGroup>
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} md="4" controlId="PhoneNumber">
              <Form.Label>Phone Number</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Phone Number"
                name="phoneNumber"
                value={formatPhoneNumber(newFacility.phoneNumber)}
                onChange={handleInputChangeNewData}
                // pattern="[0-9]*"
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                Please enter a phone number.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="4" controlId="Password">
              <Form.Label>Password</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Password"
                name="password"
                value={newFacility.password}
                onChange={handleInputChangeNewData}
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                Please enter a password.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="4" controlId="checkbox">
              <Form.Label></Form.Label>
              <Form.Check
                type="checkbox"
                id="defaultCheckbox"
                label="OTP Verification"
                className="mt-2"
                checked={!newFacility.emailVerified}
                onChange={() =>
                  handleInputChangeNewData({
                    target: {
                      name: 'emailVerified',
                      value: !newFacility.emailVerified
                    }
                  })
                }
              />
            </Form.Group>
          </Row>

          <Flex className="mt-2">
            <Button type="submit">
              {loading ? 'Loading...' : 'Create Manager'}
            </Button>
            <Button
              as={Link}
              to={paths.nursd_manager}
              variant="secondary"
              className="mx-2"
            >
              Cancel
            </Button>
          </Flex>
        </Form>
      </Card.Body>
    </Card>
  );
}

export default Create_facility;
